import { Component, ViewChild, Input, AfterContentInit, Output, EventEmitter } from '@angular/core';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { PlaceType } from '../../../../components/hub/place.category/customize.place.category.component';
import { VisitorDataCache } from '../../../../stores/visitor.calendar.store';

@Component({
  selector: 'ig-nested-menu-item',
  templateUrl: './nested.menu.item.component.html',
  styleUrls: ['./nested.menu.item.component.scss'],
})
export class NestedMenuItemComponent implements AfterContentInit {
  // need to update this to support any level nested
  public maxLevels = 3;

  constructor() {}

  @Input() item: PlaceTypeForMenu = null;
  @Input() useNonLeafMenuClick: boolean = false;
  @Output() onClick: EventEmitter<PlaceType | string> = new EventEmitter<PlaceType | string>();
  @Output() onNonLeafClick: EventEmitter<PlaceType | string> = new EventEmitter<PlaceType | string>();

  ngAfterContentInit() {
    /**
     * first time the page loads this works fine, but not for view changed. So add the menus to cache in the closeOther function
     * */
    setTimeout(() => {
      this.trigger && VisitorDataCache.addCustomDefaultPlaceCategoryMatMenus(this.trigger, this.item.level);
    });
  }

  @ViewChild('submenu')
  set subMenu(value: MatMenu) {
    this.item.subMenuEleRef = value;
  }

  @ViewChild('trigger') trigger: MatMenuTrigger;

  public select(item: PlaceType | string) {
    if (item === 'All') {
      this.onClick.emit(this.item);
    } else {
      this.onClick.emit(item);
    }
  }

  public closeOther(trigger?: MatMenuTrigger) {
    /**
     * this works for the first time the page loads, but if you redirect to map view and get back to the calendar, the menus are not in control
     * */
    for (let menu of VisitorDataCache.customDefaultPlaceCategoryMatMenus) {
      if (this.item.level === 0) menu.trigger.closeMenu();

      if (this.item.level > 0 && menu.level > 0) {
        // mouse enter the leaf level menu don't close itself
        if (this.item.level !== this.maxLevels - 1) menu.trigger.closeMenu();
      }
    }

    /**
     * the following function manually control the open and hide of the menus
     * */
    trigger && VisitorDataCache.addCustomDefaultPlaceCategoryMatMenus(trigger, this.item.level);
    trigger && trigger.openMenu();
  }

  public menuOpened() {
    setTimeout(() => {
      const menus = document.querySelectorAll('.mat-menu-panel');
      const button = document.querySelector('#filter-place-category');

      const width = `${button.getBoundingClientRect().width}px`;
      Array.from(menus).forEach((menu, index) => {
        (menu as HTMLElement).style.width = width;
        (menu as HTMLElement).style.maxWidth = width;
      });
    });
  }

  public midMenuClick(item: PlaceType | string, trigger?: MatMenuTrigger) {
    if (this.useNonLeafMenuClick) {
      this.onNonLeafClick.emit(item);
      trigger && trigger.closeMenu();
    }
  }
}

export class PlaceTypeForMenu extends PlaceType {
  public subMenuEleRef: MatMenu;
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/nested.menu/nested.menu.item/nested.menu.item.component.ts